module.exports = __webpack_public_path__ + "media/icons/neutral_status-5721f800.png";